/**
 * @internal
 */
export class DimensionalElement {
    constructor(name, type, desc, dataSource, composeCode) {
        /**
         * @internal
         */
        this.__serializable = 'DimensionalElement';
        this._name = name;
        this.type = type;
        this.description = desc || '';
        if (dataSource) {
            this._dataSource = dataSource;
        }
        if (composeCode) {
            this.composeCode = composeCode;
        }
    }
    /**
     * Defines the element's name
     */
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }
    /**
     * Defines the element's data source
     */
    get dataSource() {
        return this._dataSource;
    }
    /**
     * Gets a serializable representation of the element
     */
    serialize() {
        return {
            name: this.name,
            type: this.type,
            description: this.description,
            dataSource: this.dataSource,
            composeCode: this.composeCode,
            __serializable: this.__serializable,
        };
    }
    toJSON() {
        return this.serialize();
    }
    /**
     * Gets a string representation of the element
     */
    toString() {
        return this.jaql();
    }
}
/**
 * @param name - The name to normalize
 * @internal
 */
export function normalizeName(name) {
    // Remove all invalid characters
    let normalizedName = name.replace(/[^a-zA-Z0-9_.]/g, '').replace(/\./g, '_');
    // Prefix with '_' if it starts with a number
    const firstChar = normalizedName.charAt(0);
    if (firstChar.match(/[0-9]/)) {
        normalizedName = '_' + normalizedName;
    }
    return normalizedName;
}
//# sourceMappingURL=base.js.map